import React, { useEffect } from 'react'
import { Layout, Tabs, TabsProps, notification } from 'antd'
import { useTranslation } from 'react-i18next'
import FileMappingTab from './landing-screen/file-mapping-tab'
import FileMappingByClientTab from './landing-screen/file-mapping-by-client-tab'
import { useLocation } from 'react-router-dom'
import RichTextField from 'src/app/shared/components/common/rich-text-field'

export enum FileMappingSetTabs {
  FileMapping = 0,
  FileMappingByClient = 1,
}

const FileMappingSetup: React.FC = () => {
  const { t } = useTranslation()
  const { state } = useLocation()
  const [api, contextHolder] = notification.useNotification()
  const tabs: TabsProps['items'] = [
    {
      key: FileMappingSetTabs.FileMapping.toString(),
      label: t('FileMappingSetup:file_mapping_setup.file_mapping_tab_title'),
      children: <FileMappingTab />,
    },
    {
      key: FileMappingSetTabs.FileMappingByClient.toString(),
      label: t('FileMappingSetup:file_mapping_setup.file_mapping_by_client_tab_title'),
      children: <FileMappingByClientTab />,
    },
  ]

  useEffect(() => {
    if (state && state?.length > 0) {
      state.forEach((item: any) => {
        item.displayToast &&
          api.success({
            message: <RichTextField richText={item?.message} />,
          })
      })
    }
  }, [state])

  useEffect(() => {
    // clear location state
    window.history.replaceState({}, '')
  }, [])

  return (
    <>
      {contextHolder}
      <Layout.Content
        style={{
          padding: 24,
        }}
      >
        <Tabs defaultActiveKey={FileMappingSetTabs.FileMapping.toString()} items={tabs} destroyInactiveTabPane />
      </Layout.Content>
    </>
  )
}

export default FileMappingSetup
